var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"l5g75cki"},[_c('div',{staticClass:"l5g76h3r",style:({
            width: _vm.local.value.containerWidth,
        })},[_c('router-view',{staticClass:"l5hzimhh",attrs:{"dbNameCn":_vm.dbNameCn}}),_c('div',{staticClass:"baiduads"},[_c('BaiduAds',{attrs:{"id":"u6980841"}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }